import { render, staticRenderFns } from "./UserInfoTopBar.vue?vue&type=template&id=014cc5c4&scoped=true"
import script from "./UserInfoTopBar.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./UserInfoTopBar.vue?vue&type=script&charset=utf-8&lang=js"
import style0 from "./UserInfoTopBar.vue?vue&type=style&index=0&id=014cc5c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014cc5c4",
  null
  
)

export default component.exports